import Swiper from 'swiper/dist/js/swiper.js';

class EcoInform {
    constructor() {
        this.$items = $('.ecoinform-item');
    }

    getWidthValue(element) {
        let val = Number($(element).data('val'))
        let max = Number($(element).data('max'))

        $(element).find('.ecoinform-range__value').css({
            width: `${val / max * 100}%`
        })
    }

    init() {
        if (this.$items.length) {
            this.$items.each((i, el) => {
                this.getWidthValue(el)
            })
        }
    }
}

let ecoInform = new EcoInform();
ecoInform.init();


var arEcoSwiper = [];
window.arEcoSwiper = arEcoSwiper;

function initEcoSwiper($container, index) {
    var $el = $container,
    $elPag = $el.find('.swiper-pagination--eco'),
    $elNavLeft = $el.find('.swiper-button-next--eco'),
    $elNavRight = $el.find('.swiper-button-prev--eco'),
    $elFraction = $el.find('.swiper-fraction--eco');

    $el.addClass(`js-swiper--eco-${index}`);
    $elPag.addClass(`swiper-pagination--eco-${index}`);
    $elNavLeft.addClass(`swiper-button-next--eco-${index}`);
    $elNavRight.addClass(`swiper-button-prev--eco-${index}`);
    $elFraction.addClass(`swiper-fraction--eco-${index}`);

    return new Swiper(`.js-swiper--eco-${index}`, {
        lazy: true,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        autoHeight: true,
        simulateTouch: false,
        init: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        mousewheel: false,
        pagination: {
            el: `.swiper-pagination--eco-${index}`,
            clickable: true
        },
        navigation: {
            nextEl: `.swiper-button-next--eco-${index}`,
            prevEl: `.swiper-button-prev--eco-${index}`,
        }
    });
}

$('.js-swiper--eco').each(function (index) {
    arEcoSwiper[index] = {
        key: index,
        swiper: initEcoSwiper($(this), index)
    }
    arEcoSwiper[index].swiper.init();
});



// WEBPACK FOOTER //
// ./frontend/components/ecoinform/ecoinform.js